import { ReduxState } from 'src/store/types';

export const stardogVersionByConnectionIdSelector = (state: ReduxState) =>
  state.connections.stardogVersionByConnectionId;
